/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { documentSummariesControllerFindLatestByType } from "./documentSummariesControllerFindLatestByType";
import { summarizationsControllerFindAll } from "./summarizationsControllerFindAll";
import { summarizationsControllerFindOne } from "./summarizationsControllerFindOne";
import { summarizationsControllerGetFileContent } from "./summarizationsControllerGetFileContent";

export function documentSummariesService() {
  return { summarizationsControllerFindAll, summarizationsControllerFindOne, summarizationsControllerGetFileContent, documentSummariesControllerFindLatestByType }
}